import {
  type ConfiguratorFullResetResult,
  sendConfiguratorFullReset,
} from "~/features/configurator/common/api/configuratorCommandApi";
import type { LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";

export async function sendCarriageResetConfigurator(
  state: LinearConfiguratorState,
): Promise<ConfiguratorFullResetResult> {
  const payload = await sendConfiguratorFullReset(state);
  return {
    configuration: transform(payload.data, ConfiguratorType.Carriage),
    helpUrl: payload.helpUrl,
  };
}
